import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { BalanceService, CurrencyType, microableCurrency } from '@app/core/balance.service';
import { merge } from 'rxjs/observable/merge';
import { Subscription } from 'rxjs/Subscription';
import { ServerType } from '@app/games/models/server-type.model';
import { Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class PlayerService {
  private currency: CurrencyType = this.getCurrency();
  private currencyString: string = this.getCurrencyString();
  private subs: Subscription = new Subscription();
  constructor(private auth: AuthenticationService, private balance: BalanceService, private router: Router) {
    this.subs.add(
      this.currencyObservable()
        .pipe(filter((currency: CurrencyType) => currency !== this.currency))
        .subscribe((curreny: CurrencyType) => {
          this.getCurrency();
          this.getCurrencyString();
        })
    );
  }

  public makeChange() {
    return merge(this.auth.credentials$, this.currencyObservable());
  }

  public currencyObservable() {
    return merge(this.auth.onModeChanged$, this.balance.currencyObservable()).pipe(map(() => this.getCurrency()));
  }

  public getCurrency(): CurrencyType {
    this.currency = this.isRealMoney() ? this.balance.getCurrency() : CurrencyType.DEMO;
    return this.currency;
  }

  public getCurrencyString(): string {
    this.currencyString = this.getCurrency()
      .toString()
      .toLowerCase();
    return this.currencyString;
  }

  public getCurrencyLabel(): string {
    if (this.microable()) {
      return (this.balance.getMicroViewer() ? 'm' : '') + this.currency.toUpperCase();
    }
    return this.currency.toUpperCase();
  }

  public isRealMoney(): boolean {
    return this.auth.isAuthenticated() && this.auth.isMainServer();
  }

  public getBalance(): number {
    return this.isRealMoney() ? this.balance.getCurrentBalance() : this.auth.demoBalance;
  }

  public microable(): boolean {
    return microableCurrency(this.getCurrency());
  }

  public init(): void {
    const gameMode = this.router.url.indexOf('mode=demo') !== -1 ? ServerType.Server : ServerType.Main;
    if (gameMode !== this.auth.server) {
      this.auth.setMode(gameMode);
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/player.service.ts